import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ThirdpartyIntegrationType } from 'api/integrations';
import { TaskCreated } from 'api/notifications/meta';
import { Avatar } from 'components/atoms/avatar';
import { useExternalIntegrationUserDetails } from 'hooks/use-external-integration-user-details';
import { InlineLink, Strong } from '../basics';
import { Causer } from './causer';

export const TaskCreatedView: FC<{
  meta: TaskCreated;
  open: () => void;
  isTaskWithFormInstance: boolean;
}> = ({ meta: { by, title, externalUser }, open, isTaskWithFormInstance }) => {
  const userDetails = useExternalIntegrationUserDetails(externalUser, by);

  if (externalUser?.integrationType === ThirdpartyIntegrationType.Form) {
    return (
      <FormattedMessage
        id="notifications.messages.task_created_via_form"
        values={{
          causer: externalUser?.name ? (
            <>
              <Avatar size="small" name={externalUser?.name} />
              <Strong>{externalUser?.name}</Strong>
            </>
          ) : (
            <Causer user={userDetails} />
          ),
          title: <InlineLink title={title} open={open} />,
        }}
      />
    );
  }

  return (
    <FormattedMessage
      id={
        isTaskWithFormInstance
          ? 'notifications.messages.form_task_created'
          : 'notifications.messages.task_created'
      }
      values={{
        causer: <Causer user={userDetails} />,
        title: <InlineLink title={title} open={open} />,
      }}
    />
  );
};
